import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Switch/switch';
import { css } from '@patternfly/react-styles';
import CheckIcon from '@patternfly/react-icons/dist/js/icons/check-icon';
import { getUniqueId } from '../../helpers/util';
import { getOUIAProps } from '../../helpers';
export var Switch =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch(props) {
    var _this;

    _classCallCheck(this, Switch);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Switch).call(this, props));

    if (!props.id && !props['aria-label']) {
      // eslint-disable-next-line no-console
      console.error('Switch: Switch requires either an id or aria-label to be specified');
    }

    _this.id = props.id || getUniqueId();
    return _this;
  }

  _createClass(Switch, [{
    key: "render",
    value: function render() {
      var _a = this.props,
          id = _a.id,
          className = _a.className,
          label = _a.label,
          labelOff = _a.labelOff,
          isChecked = _a.isChecked,
          isDisabled = _a.isDisabled,
          _onChange = _a.onChange,
          ouiaId = _a.ouiaId,
          props = __rest(_a, ["id", "className", "label", "labelOff", "isChecked", "isDisabled", "onChange", "ouiaId"]);

      var isAriaLabelledBy = props['aria-label'] === '';
      return React.createElement("label", Object.assign({
        className: css(styles.switch, className),
        htmlFor: this.id
      }, getOUIAProps('Switch', ouiaId)), React.createElement("input", Object.assign({
        id: this.id,
        className: css(styles.switchInput),
        type: "checkbox",
        onChange: function onChange(event) {
          return _onChange(event.target.checked, event);
        },
        checked: isChecked,
        disabled: isDisabled,
        "aria-labelledby": isAriaLabelledBy ? "".concat(this.id, "-on") : null
      }, props)), label !== undefined ? React.createElement(React.Fragment, null, React.createElement("span", {
        className: css(styles.switchToggle)
      }), React.createElement("span", {
        className: css(styles.switchLabel, styles.modifiers.on),
        id: isAriaLabelledBy ? "".concat(this.id, "-on") : null,
        "aria-hidden": "true"
      }, label), React.createElement("span", {
        className: css(styles.switchLabel, styles.modifiers.off),
        id: isAriaLabelledBy ? "".concat(this.id, "-off") : null,
        "aria-hidden": "true"
      }, labelOff !== undefined ? labelOff : label)) : React.createElement("span", {
        className: css(styles.switchToggle)
      }, React.createElement("div", {
        className: css(styles.switchToggleIcon),
        "aria-hidden": "true"
      }, React.createElement(CheckIcon, {
        noVerticalAlign: true
      }))));
    }
  }]);

  return Switch;
}(React.Component);
Switch.defaultProps = {
  isChecked: true,
  isDisabled: false,
  'aria-label': '',
  onChange: function onChange() {
    return undefined;
  }
};